<template>
  <div class="my-3 d-flex flex-column justify-content-center">
    <div class="d-flex me-3 col-12">
      <div class="d-flex align-items-center col-2">
        <img
          class="mx-3 opacity-0"
          src="@/assets/icons/arrow-blue.svg"
          alt=""
        />
        <div class="bg-primary list-id me-3 position-relative">
          <img src="@/assets/icons/divider.svg" alt="" />
        </div>
      </div>
      <div class="title-wrapper px-2 my-2">
        <input type="text" placeholder="標題" class="title" v-model="title" />
      </div>
      <div class="function-img my-2 d-flex align-items-center pb-2">
        <img
          @click="closeBtnList = false"
          v-if="closeBtnList"
          src="@/assets/icons/edit.svg"
          alt=""
        />
        <img
          @click="$emit('copyItem', [element, $attrs.qIndex])"
          src="@/assets/icons/list-copy.svg"
          class="mx-3"
          alt=""
          v-c-popover="{
            content: '複製',
            placement: 'top',
            trigger: 'hover',
          }"
        />
        <img
          @click="$emit('deleteItem', element)"
          src="@/assets/icons/delete.svg"
          :class="sortMode ? 'me-3' : ''"
          v-c-popover="{
            content: '刪除',
            placement: 'top',
            trigger: 'hover',
          }"
          alt=""
        />
        <img src="@/assets/icons/list-sort.svg" class="me-3 handle" alt="" />
      </div>
    </div>
    <div class="col-12 mb-5 d-flex justify-content-end flex-column">
      <div v-if="!closeBtnList" class="col-12 d-flex">
        <div class="col-2"></div>
        <button
          class="rounded p-1 mt-2 mx-2 btn remark-btn"
          :class="showSettingLine ? 'btn-primary' : 'btn-secondary'"
          @click="useRemark"
        >
          分隔線設定
        </button>
      </div>
    </div>
    <div
      v-if="!closeBtnList"
      class="d-flex align-items-center justify-content-between col-12 p-3 close-btn-group"
    >
      <div
        class="d-flex col-3 align-items-center justify-content-between type-text-wrapper"
      >
        <span>題項類型：</span>
        <div class="type-text">分隔線</div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from '@vue/reactivity'
export default {
  emits: ['deleteItem'],
  setup() {
    const closeBtnList = ref(false)
    const title = ref('')
    const showSettingLine = ref(false)
    return {
      closeBtnList,
      title,
      showSettingLine,
    }
  },
}
</script>
<style lang="scss" scoped>
.title-wrapper {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #9ca0a8;
  outline: none;
}
.title {
  width: 100%;
  border: 0;
  outline: none;
}

.remark-btn {
  font-size: 14px;
  color: #fff;
}

.list-id {
  width: 40px;
  height: 40px;
  background: #177baf;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  span {
    left: 5px;
  }
}
.function-img {
  border-bottom: 1px solid #9ca0a8;
  img {
    cursor: pointer;
  }
}
.close-btn-group {
  background: rgba(23, 123, 175, 0.1);
  border-radius: 0px 0px 20px 20px;
}
.type-text-wrapper {
  font-size: 12px;
}
.type-text {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border-radius: 3px;
  padding: 6px 10px;
  font-size: 16px;
  width: 98px;
}
</style>
